import {addDays, differenceInHours, parse} from "date-fns";
import {DATE_FORMATS} from "../../../constants/DateFormats";
import {contrastTextColour} from "./ColourHelper";
import React from "react";

const ORDER_EVENT_BORDER_COLOR              = '#151515';
const DELIVERY_EVENT_BORDER_COLOR           = '#151515';
const INSTALLATION_EVENT_BORDER_COLOR       = '#151515';
const LEAVE_EVENT_BORDER_COLOR              = '#151515';
/**
 * EventHelper::addEventStylingProps()
 *
 * @param event
 * @returns {*}
 */
export const addEventStylingProps = (event) => {
    switch (event.event_model) {
        case 'App\\Models\\Order':
            event.borderColor       = ORDER_EVENT_BORDER_COLOR;
            event.allDay            = true;
            break;
        case 'App\\Models\\Delivery':
            event.borderColor       = DELIVERY_EVENT_BORDER_COLOR;
            event.textColor         = contrastTextColour(event.backgroundColor);
            event.allDay            = true;
            event.title             = '';
            break;
        case 'App\\Models\\Installation':
            event.borderColor       = INSTALLATION_EVENT_BORDER_COLOR;
            event.textColor         = contrastTextColour(event.backgroundColor);
            event.allDay            = true;
            break;
        case 'App\\Models\\UserLeaveRequest':
            event.borderColor       = LEAVE_EVENT_BORDER_COLOR;
            event.textColor         = contrastTextColour(event.backgroundColor);
            event.allDay            = true;
            break;

    }

    return event;
}

/**
 * EventHelper::getEventNode()
 *
 * @param event
 * @returns {JSX.Element}
 */
export const getEventNode = (event) => {
    switch (event.event_model) {
        case 'App\\Models\\Order':
            return (
                <div className={"px-1"}>
                    <span className={"font-weight-bold"}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: event.complete
                            }}>
                        </span>
                        &nbsp;Order:&nbsp;
                    </span>
                    {event.details.customer}
                </div>
            );
        case 'App\\Models\\Delivery':
            return (
                <div className={"px-1"}>
                    <span className={"font-weight-bold"}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: event.complete
                            }}>
                        </span>
                        &nbsp;Delivery:&nbsp;
                    </span>
                    {event.details.customer}
                </div>
            );
        case 'App\\Models\\Installation':
            return (
                <div className={"px-1"}>
                    <span className={"font-weight-bold"}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: event.complete
                            }}>
                        </span>
                        &nbsp;Installation:&nbsp;
                    </span>
                    {event.details.customer}
                </div>
            );
        case 'App\\Models\\UserLeaveRequest':
            return (
                <div className={"px-1"}>
                    <span className={"font-weight-bold"}>Leave:&nbsp;</span>{event.details.user}
                </div>
            );
    }
}

/**
 * EventHelper::getEventTitle()
 *
 * @param event
 * @returns string
 */
export const getEventTitle = (event) => {
    switch (event.event_model) {
        case 'App\\Models\\Order':
            return "Order: "+event.details.customer+" - "+event.details.job_name+" - "+event.details.name;
        case 'App\\Models\\Delivery':
            return "Delivery: "+event.details.customer+" - "+event.details.job_name;
        case 'App\\Models\\Installation':
            return "Installation: "+event.details.customer+" - "+event.details.job_name;
        case 'App\\Models\\UserLeaveRequest':
            return "Leave: "+event.details.user;
    }
}

/**
 * EventHelper::parseEventData()
 *
 * @param data
 * @returns {*[]}
 */
export const parseEventData = (data) => {
    const parsedEvents = [];

    for (let i = 0; i < data.length; i++) {
        let event = data[i];
        event.start = parse(event.start, DATE_FORMATS.DB, new Date());
        event.end = parse(event.end, DATE_FORMATS.DB, new Date());

        event = addEventStylingProps(event);

        /**
         * Check if the event spans multiple days.
         * If so add an extra day due to how the calendar library functions.
         */
        if (differenceInHours(event.end, event.start) >= 24) {
            event.end = addDays(event.end, 1);
        }

        parsedEvents.push(event);
    }

    return parsedEvents;
}

/**
 * EventHelper::getEventById()
 *
 * @param eventId
 * @param events
 * @returns {*}
 */
export const getEventById = (eventId, events) => {
    for (let i = 0; i < events.length; i++) {
        if (events[i].id === eventId) {
            return events[i];
        }
    }
}
